export default __webpack_public_path__ + "static/media/partner-dw-consulting.0a36b397.jpg";